const external_links = document.querySelectorAll(".navigation .external a");
external_links.forEach(ele => ele.setAttribute("target", "_blank"));
